import workingImg from "../../../assets/images/working_tire.png";

export default function WorkingHardPage() {
  return (
    <div className="flex items-center justify-center">
      <div className="m-6 w-full max-w-lg overflow-hidden rounded-xl bg-white shadow-md border border-gray-200">
        <div className="p-8 text-center animate-fadeIn">
          <img
            className="max-h-28 mx-auto mb-6"
            alt="Tire character preparing"
            src={workingImg}
          />

          <h1 className="font-serif text-2xl sm:text-3xl font-bold text-gray-800 mb-3">
            We're working on it!
          </h1>

          <p className="font-sans text-gray-600 mt-5 max-w-md mx-auto text-sm sm:text-base">
            This feature isn't available yet, but our team is hard at work
            making it happen. Check back soon!
          </p>
        </div>
      </div>
    </div>
  );
}
